<template>
  <div>
    <g-master name="trabajos"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              ref="master"
              :beforeSend="master.beforeSend"
              @action="masterAction"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="`${master.endpoint}_/downloadExcel`" :params="paramsExcel" fileName="HABILIDADES Y CONOCIMIENTOS"/>
      </template>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-dropdown :label="$t('Nivel del cargo')"
                        :formItemConfig="fiOptions"
                        endpoint="level_competency"
                        :selectedObj.sync="nivelCargoSeleccionado"
                        :params="{filtra_por_evaluacion: true, id_evaluation: id_evaluation}"
                        :decorator="['id_level_competency', { rules: [{ required: true, message: 'Valor requerido' }] }]">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown :label="$t('Cargo')"
                        :formItemConfig="fiOptions"
                        endpoint="level_compency_job"
                        :params="{filtra_por_nivel_cargo: true, id_evaluation: id_evaluation, nivel_cargo_seleccionado: nivelCargoSeleccionado}"
                        :decorator="['id_job', { rules: [{ required: true, message: 'Valor requerido' }] }]">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="rol_competency"
                        :label="$t('Roles') "
                        :selectConfig="{mode:'multiple'}"
                        :params="rol_params"
                        :formItemConfig="fiOptions"
                        :decorator="['roles', { rules: [{ required: false, message: 'Valor requerido' }] }]"
            >
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Valor (peso)')">
              <a-input-number style="width: 100%"
                              v-decorator="['value', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        visible: false,
        nombre: '',
        nivelCargoSeleccionado: {},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          beforeSend: (data) => {
            data.id_skill = this.id_skill
            if (!this.$isEmpty(data.roles)) {
              data.roles = data.roles.join()
            }
            return data
          },
          endpoint: 'skill_job_level',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Cargo', dataIndex: 'job_name', sorter: true},
              {title: 'Nivel del cargo', dataIndex: 'description', sorter: true},
              {title: 'Roles permitidos', dataIndex: 'roles_desc', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_job'},
            {name: 'id_level_competency'},
            {name: 'value'},
            {name: 'roles'}
          ]
        },
        paramsT: {}
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.nivelCargoSeleccionado = {}
            break
          case 'masterEdit':
            if (!this.$isEmpty(action.record.id_level_competency)) {
              this.nivelCargoSeleccionado = {value: action.record.id_level_competency}
            }
            if (!this.$isEmpty(action.record.roles)) {
              this.$refs.master.modal.form.setFieldsValue({
                roles: action.record.roles.split(',')
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                roles: undefined
              })
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    props: ['id_skill', 'id_evaluation'],
    computed: {
      parentData () {
        return {
          id_skill: this.id_skill
        }
      },
      rol_params () {
        return {id_evaluation: this.id_evaluation}
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillJobLevel.vue